﻿/**
 * settings-service.js
 * Legacy-backed settings facade used during refactor.
 */
export class SettingsService {
  constructor(gateway) {
    this.gateway = gateway;
  }

  get() {
    return this.gateway.load();
  }

  save(settings) {
    return this.gateway.save(settings);
  }
}
